import React from "react"
import { IBackgroundColor, ILink, INotFullBanner } from "../../../gatsby-graphql"
import { Button } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import { SectionProps } from "../section-loader"
import {
  Background,
  BackgroundWrapper,
  Content,
  ContentButtons,
  ContentDescription,
  ContentWrapper,
  SectionWrapper,
  RowWrapper,
  BannerInfoWrapper,
  LogoWrapper,
  Label,
  GameLogo,
  BannerInfoHeader,
} from "./not-full-width-banners-elements"
import getBackground from "../../helpers/getBackground"

interface NotFullWidthBannersProps extends SectionProps {
  data: {
    banners?: INotFullBanner[]
  }
}

const NotFullWidthBanners = ({ data, locale }: NotFullWidthBannersProps) => {
  let height: number | undefined

  if (!data.banners || data.banners.length <= 0) {
    return <></>
  }

  const getColor = (color: string): string => {
    if(color && color.includes("hex")) {
      return window.JSON.parse(color).hex;
    } else if (color.length >= 5) {
      return color.includes("#") ? `${color}` : `#${color}`;
    }else{
      return "";
    }
  }

  return (
    <SectionWrapper>
      <RowWrapper>
      <BackgroundWrapper>
        {data.banners.map((banner, index) => {
          if (!height || height > (banner?.asset?.height || height)) {
            height = banner?.asset?.height || height
          }
          return <Background imgSrc={banner.asset?.url ? banner.asset.url : ''} key={index} />
        })}
      </BackgroundWrapper>
      <ContentWrapper>
        <Content>
        {data.banners.map((banner, index) => (
          <BannerInfoWrapper background={banner.backgroundColor ? getBackground(banner.backgroundColor) : ""}  key={index}>
            <LogoWrapper>
              {banner.label?.text && <Label color={banner.label?.color ? getColor(banner.label.color) : ""}>{banner.label?.text}</Label>}
              <GameLogo src={banner.gameLogo?.url ? banner.gameLogo.url : ''} alt={banner.gameLogo?.name ? banner.gameLogo?.name : ""}/>
            </LogoWrapper>
            <BannerInfoHeader>{banner.header}</BannerInfoHeader>
            {banner.buttons && banner.buttons.length > 0 && (
              <ContentButtons>
                {banner.buttons.map((button, index) => (
                  <Button
                    type={button?.type as ButtonType}
                    link={button?.link as ILink}
                    locale={locale}
                    key={index}
                  >{button?.name}</Button>
                ))}
              </ContentButtons>
            )}
          </BannerInfoWrapper>
        ))}
        </Content>
      </ContentWrapper>
      </RowWrapper>
    </SectionWrapper>
  )
}

export default NotFullWidthBanners
